import { render, staticRenderFns } from "./MainPageFloatButton.vue?vue&type=template&id=6720b9a8"
import script from "./MainPageFloatButton.vue?vue&type=script&lang=js"
export * from "./MainPageFloatButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports